module.exports = __webpack_public_path__ + "static/img/qm03_wrap_bg.5b63046d.png";